import React from "react";
import { getRightworkAPI } from "../requests/utilities/requests";
import { API_get_tip_policies } from "../../../constants";
import TipPoolsDisplay from "../locations_integrations_hours_settings/TipPoolsDisplay";

// The Tip pool policies page under the Tip pooling feature row: loads the
// company's policies itself (the settings grid opens it on demand, like Roles,
// departments & stations) and hands the payload to the policy editor. A refresh
// that fails after a save keeps the last good payload, marked, instead of
// blanking the page.
export default function TipPoolsSettingsEditor({ companyId, permissionRole, onDirtyChange, active = true }) {
  const [payload, setPayload] = React.useState(null);
  const requested = React.useRef(companyId);
  const load = React.useCallback(async () => {
    requested.current = companyId;
    let next;
    try {
      const res = await getRightworkAPI(API_get_tip_policies, { company_id: companyId });
      next = res?.data?.redux?.payload ? res.data.redux.payload : { error: true, company_id: companyId };
    } catch (error) {
      next = { error: true, company_id: companyId };
    }
    if (requested.current !== companyId) return;
    setPayload((previous) => (next.error && previous && !previous.error ? { ...previous, refresh_failed: true } : next));
  }, [companyId]);
  React.useEffect(() => { setPayload(null); load(); }, [load]);
  // The settings grid keeps this page mounted while it is hidden; when it
  // comes back on screen the locations may have changed (tip pooling turned
  // on somewhere), so the policies and their assignable locations reload.
  const wasActive = React.useRef(active);
  React.useEffect(() => {
    if (active && !wasActive.current) load();
    wasActive.current = active;
  }, [active, load]);
  return (
    <TipPoolsDisplay
      key={`tip-pools:${companyId}`}
      companyId={companyId}
      payload={payload}
      isAdmin={["rightwork_internal", "company_admin"].includes(permissionRole)}
      onChanged={load}
      onDirtyChange={(key, dirty) => onDirtyChange?.(dirty)}
    />
  );
}
